import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import RutaProtegida from 'componentes/layout/RutaProtegida';

const LoginPagina = lazy(() => import('paginas/login/LoginPagina'));
const UsuariosPagina = lazy(() => import('paginas/usuarios/UsuariosPagina'));
const CargaUsuariosPagina = lazy(() => import('paginas/cargaUsuarios/CargaUsuariosPagina'));
const VehiculosPagina = lazy(() => import('paginas/vehiculos/VehiculosPagina'));
const VigilantesPagina = lazy(() => import('paginas/personas/VigilantesPagina'));
const TecnicosPagina = lazy(() => import('paginas/personas/TecnicosPagina'));
const TecnicoSmaPagina = lazy(() => import('paginas/personas/TecnicoSmaPagina'));
const TecnicoSseiPagina = lazy(() => import('paginas/personas/TecnicoSseiPagina'));
const TecnicoLoomisPagina = lazy(() => import('paginas/personas/TecnicoLoomisPagina'));
const ConfiguracionPagina = lazy(() => import('paginas/configuracion/ConfiguracionPagina'));

const RutasAplicacion = () => (
  <Suspense fallback={<div>Cargando...</div>}>
    <Routes>
      <Route path="/login" element={<LoginPagina />} />
      <Route
        path="/usuarios"
        element={
          <RutaProtegida requiredRole="ADMIN" requiredPolicy="politicaVerUsuarios">
            <UsuariosPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/CargaUsuarios"
        element={
          <RutaProtegida requiredRole="ADMIN" requiredPolicy="politicaVerUsuarios">
            <CargaUsuariosPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/lista"
        element={
          <RutaProtegida requiredPolicy="politicaVerVistaUnidadesMoviles">
            <VehiculosPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/vigilantes"
        element={
          <RutaProtegida requiredPolicy="politicaVerVigilantes">
            <VigilantesPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/tecnicos"
        element={
          <RutaProtegida requiredPolicy="politicaVerTecnicosComdata">
            <TecnicosPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/tecnicos-sma"
        element={
          <RutaProtegida requiredPolicy="politicaVerSma">
            <TecnicoSmaPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/tecnicos-ssei"
        element={
          <RutaProtegida requiredPolicy="politicaVerSsei">
            <TecnicoSseiPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/tecnicos-loomis"
        element={
          <RutaProtegida requiredPolicy="politicaVerTecnicosLoomis">
            <TecnicoLoomisPagina />
          </RutaProtegida>
        }
      />
      <Route
        path="/configuracion"
        element={
          <RutaProtegida>
            <ConfiguracionPagina />
          </RutaProtegida>
        }
      />
    </Routes>
  </Suspense>
);

export default RutasAplicacion;
